module.exports = __webpack_public_path__ + "static/media/KritikResume.6e472e9e.pdf";